import { Button as MantineButton } from "@mantine/core";

function Button({ label, onClick, type = "button", disabled }) {
  return (
    <MantineButton
      fullWidth
      radius="xl"
      size="md"
      type={type}
      onClick={onClick}
      disabled={disabled}
      styles={{
        root: {
          backgroundColor: "black",
          color: "white",
          fontWeight: "bold",
          boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
          transition: "all 0.3s ease",
          "&:hover": {
            backgroundColor: "white",
            color: "black",
          },
        },
      }}
    >
      {label}
    </MantineButton>
  );
}

export default Button;
